import { useAppSelector } from '@src/core/hooks';
import { directLinkStateSelector } from '@src/stores/directLink';

// True when item prices should be shown. False for cart-type direct links,
// where items are sold at the seller's agreed total and per-item RM prices
// are hidden. Safe outside the direct-link flow: directLink is undefined there.
export const useShowItemPrices = (): boolean => {
  const { directLink } = useAppSelector(directLinkStateSelector);
  return directLink?.type !== 'cart';
};

export default useShowItemPrices;
